import {
  LayoutListDefinition,
  LAYOUT_LIST,
  EDITABLE_CARD_WRAPPER,
  CARD_FORM_PLACEHOLDER
} from '../../items';
import { Translator } from '../../Translator';
import { CardHelper } from '../itemHelpers/CardHelper';
import { TextHelper } from '../itemHelpers/TextHelper';
import { ItemOfType } from '../itemHelpers/types';
import { translate } from '../translate';
import { useEditorStore } from '~/shell/Store';
import { EditableCardWrapperDefinition } from '~/editor/v2/cards/EditableCardWrapper';
import { CardFormPlaceholderDefinition } from '~/editor/v2/cards/CardFormPlaceholder';
import { imageAudioTextCardTemplate } from './templates/imageAudioTextCard';

export const Cards5: Translator = sequence => {
  const { contentEditable } = useEditorStore.getState();

  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: 'center',
      padded: true,
      wrap: true,
      type: 'ul'
    },
    items: []
  } as LayoutListDefinition;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Card') {
      const cardDefinition = CardHelper(item as ItemOfType<'Card'>, {
        height: 'unset',
        width: '269px',
        padding: '0px',
        isImageDecorative: true,
        type: contentEditable ? 'div' : 'li',
        replay: true,
        centerTitle: true,
        editable: false
      });

      if (contentEditable) {
        cardsList.items.push({
          type: EDITABLE_CARD_WRAPPER,
          id: `${sequence.id}.wrapper.${item.id}`,
          values: {
            cardId: item.id,
            width: '269px',
            height: 'unset',
            cardTemplates: [imageAudioTextCardTemplate]
          },
          items: [cardDefinition]
        } as EditableCardWrapperDefinition);
      } else {
        cardsList.items.push(cardDefinition);
      }
    } else if (item.__typename === 'Text') {
      mainList.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            align: 'center'
          },
          items: TextHelper(item as ItemOfType<'Text'>)
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  mainList.items.push(cardsList);

  if (contentEditable) {
    cardsList.items.push({
      type: CARD_FORM_PLACEHOLDER,
      id: `${sequence.id}.add-card-placeholder`,
      values: {
        sequenceId: sequence.id,
        width: '270px',
        height: '380px',
        text: 'Add a card',
        maxCards: 6,
        cardTemplate: imageAudioTextCardTemplate
      },
      items: []
    } as CardFormPlaceholderDefinition);
  }

  if (mainList.items.length > 1) {
    mainList.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.blank`
    } as LayoutListDefinition);
  }
  root.items.push(mainList);

  return root;
};
